import { cloneElement, type ReactElement } from 'react';
import { Tooltip, type DatePickerProps } from 'antd';

import { nonWorkingDay } from '@/utils/german_holidays';

type CellRender = NonNullable<DatePickerProps['cellRender']>;

/**
 * Markiert Samstage, Sonntage und Feiertage (NRW) im Tagesraster jedes
 * Kalenders (#206). Nur eine Klasse am `.ant-picker-cell-inner`, die Farben
 * liegen in `index.css`, damit antds Zustände (ausgewählt, deaktiviert,
 * Nachbarmonat, Hover) Vorrang behalten — die kennt `cellRender` nicht.
 * Feiertage nennen ihren Namen per Tooltip; `title=""` unterdrückt dabei den
 * nativen Datums-Tooltip, den rc-picker an die Zelle hängt. Monats-, Jahres-
 * und Zeitansichten bleiben unberührt.
 */
export const renderCalendarCell: CellRender = (current, info) => {
  if (info.type !== 'date' || typeof current !== 'object') return info.originNode;

  const mark = nonWorkingDay(current.year(), current.month() + 1, current.date());
  if (!mark) return info.originNode;

  const origin = info.originNode as ReactElement<{ className?: string; title?: string }>;
  const cell = cloneElement(origin, {
    className: `${origin.props.className ?? ''} calendar-day--${mark.kind}`,
    ...(mark.kind === 'holiday' ? { title: '' } : {}),
  });
  return mark.kind === 'holiday' ? (
    <Tooltip title={`${mark.name} (Feiertag NRW)`} mouseEnterDelay={0.2}>
      {cell}
    </Tooltip>
  ) : (
    cell
  );
};
